import { fetchKeyFigures } from "./data/dataFetching";
import { extractRequestBodyFromFilters, updateFilters } from "./data/keyFiguresFilters";

export async function updateKeyFiguresPageState(companyAccess, languageKey, filters, setFilters, setData) {
  const response = await fetchKeyFigures(
    languageKey,
    extractRequestBodyFromFilters(filters, filters.isInitialLoad),
    (error) => console.error(error),
    companyAccess
  );
  const payload = response?.data?.reportData ? response.data : response?.data?.data;
  if (!payload?.context || !Array.isArray(payload?.reportData?.businessKeyFigures)) {
    throw new Error("Invalid business-key-figures response");
  }
  const updatedFilters = await updateFilters(
    filters, payload.context.filters || {}, payload.context.nextAvailableFilters || {},
    filters.isInitialLoad, companyAccess, languageKey
  );
  setFilters(updatedFilters);
  setData(payload);
}
